export default __webpack_public_path__ + "static/media/table-cells-large.3d93f211.svg";